import Button from "../../ui-components/Button";
import {useIntl} from "react-intl";
import {useState, useContext} from "react";
import Modal from "../../ui-components/Modal";
import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";
import CountryContext from "../../CountryContext";
const DeleteUserDocumentsDialog = ({worksiteId, documents, onClose, setUserLoadedDocuments }) => {

	const intl = useIntl();
	const [loading, setLoading] = useState(false);
	const {country} = useContext(CountryContext);
	const countryApiRequest = useCountryAxiosInstance(country.code);
	const handleDelete = async () => {
		setLoading(true);
		const promises = documents.map(async (document) => {
			await countryApiRequest.delete(`/worksite_documents/document/${document.id}`)
		})
		await Promise.all(promises)
		const newUserLoadedDocuments = await countryApiRequest.get(`/worksite_documents/${worksiteId}`);
		setUserLoadedDocuments(newUserLoadedDocuments);
		setLoading(false);
		onClose();
	}

	return <Modal
		title={intl.formatMessage({id: "delete_documents"})}
		onExit={onClose}
	>
		<div className={"grid grid-cols-1 gap-y-10 justify-items-center"}>
			<div>
			<span>
				{intl.formatMessage({id: "delete_documents_confirmation_message"})}
			</span>
			</div>
			{/*confirm and cancel buttons*/}
			<div className={"flex grid grid-cols-2 items-center justify-items-center"}>
				<div className={"justify-center"}>
				<Button
					onClick={handleDelete}
					submitting={loading}
					styleType={"danger"}
				>
					{intl.formatMessage({id: "confirm"})}
				</Button>
				</div>
				<div className={"justify-center"}>
				<Button
					onClick={onClose}
					styleType={"white"}
				>
					{intl.formatMessage({id: "cancel"})}
				</Button>
				</div>
			</div>
		</div>
	</Modal>
}

export default DeleteUserDocumentsDialog;